/**
 * @generated SignedSource<<56fe7f07b2a56b2ea6ef2deb36d98562>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type renderChildRows_nativeIssueTable_RenderChildRowsComp$data = {
  readonly aliases?: ReadonlyArray<string> | null | undefined;
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentType": "renderChildRows_nativeIssueTable_RenderChildRowsComp";
};
export type renderChildRows_nativeIssueTable_RenderChildRowsComp$key = {
  readonly " $data"?: renderChildRows_nativeIssueTable_RenderChildRowsComp$data;
  readonly " $fragmentSpreads": FragmentRefs<"renderChildRows_nativeIssueTable_RenderChildRowsComp">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aliases"
        }
      ]
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "4936ec55b13e15c77eab8e846dffecd4";

export default node;
